<template>
  <div>
    <md-field v-if="remoteData.length === 0">
      <md-skeleton title :loading="remoteDataLoading" :row="8">
        <md-cell-item>无数据</md-cell-item>
        <md-cell-item v-if="this.remoteError">{{this.remoteError}}</md-cell-item>
      </md-skeleton>
    </md-field>

    <md-field v-if='hospital'>
      <md-cell-item :title="'【' + hospital.name + '】'"></md-cell-item>
      <md-cell-item v-for="item of remoteData.departmentList" :key="item.id" :title="item.name" @click="onItemClick(item.id, item.name)" arrow></md-cell-item>
    </md-field>

    <md-field>
      <md-button @click="onGotoSetting">我的...</md-button>
    </md-field>

  </div>
</template>

<script>
import cookie from "@utils/store/cookie"
import { mapGetters } from "vuex"
import { departmentOfHospital } from '../api/daOrder'
import { patientCreate } from '../api/daSetting'
import { Field, CellItem, Skeleton, Button } from 'mand-mobile'
export default {
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Skeleton.name]: Skeleton,
    [Button.name]: Button
  },
  data () {
    return {
      remoteData: [],
      remoteError: null,
      remoteDataLoading: false,
      /* 第三方传递进来的就诊人信息 begin */
      psex: this.$route.query.psex || null,
      pname: this.$route.query.pname || null,
      pmobile: this.$route.query.pmobile || null,
      pbirthday: this.$route.query.pbirthday || null
      /* 第三方传递进来的就诊人信息 end */
    }
  },
  computed: {
    ...mapGetters(['hospital'])
  },
  mounted () {
    if (this.pname) {
      const param = {
        name: this.pname,
        sex: this.psex,
        phone: this.pmobile,
        birthday: this.pbirthday
      }
      patientCreate(param).then(res => {
        //nothing
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    const departmentId = this.$route.query.d || null
    if (departmentId) {
      this.$router.replace({
        path: 'department',
        query: {
          id: departmentId,
          name: ''
        }
      })
      return
    }

    let hospitalId = this.$route.query.h || null
    if (hospitalId != null) {
      cookie.set('hospital', hospitalId)
    }
    hospitalId = cookie.get('hospital') || null

    if (!hospitalId) {
      this.remoteError = '医院参数不正确'
      return
    }

    this.remoteDataLoading = true
    this.remoteError = null
    this.remoteData = []
    departmentOfHospital(hospitalId).then(res => {
      this.remoteDataLoading = false
      if (res.data && res.status === 200) {
        this.$store.commit("UPDATE_HOSPITAL", res.data.hospital)
        this.remoteData = res.data
      } else {
        this.remoteError = res.msg
      }
    }).catch(err => {
      console.log('departmentOfHospital.err', err)
      this.remoteDataLoading = false
      if ( err.msg ) {
        this.remoteError = err.msg
      } else {
        this.remoteError = err
      }
    })
  },
  methods: {
    onItemClick (deptId, deptName) {
      this.$router.push({
        path: 'department',
        query: {
          id: deptId,
          name: deptName
        }
      })
    },
    onGotoSetting() {
      this.$router.push({
        path: '/setting'
      })
    }
  }
}
</script>
